function setMenuSelection() {

    var current = location.pathname;
    $('.side-menu li a').each(function () {
        const $this = $(this);
        if ($this.attr('href').indexOf(current) !== -1) {
            $this.addClass('active');
        }
    });
} 